import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import LeadForm from './LeadForm';

const Popup = ({ isOpen, onClose }) => (
  <Dialog open={isOpen} onOpenChange={onClose}>
    <DialogContent className="sm:max-w-[500px]">
      <DialogHeader>
        <DialogTitle className="text-2xl font-bold text-center text-primary">
          Protect Your Brand Now
        </DialogTitle>
        <p className="text-center text-sm text-gray-500 mt-1">
          Speak with a trademark expert — free consultation, no obligations.
        </p>
      </DialogHeader>
      <LeadForm idPrefix="popup" onSuccess={onClose} />
    </DialogContent>
  </Dialog>
);

export default Popup;
